export default __webpack_public_path__ + "static/media/enquiry.a91fb506.svg";